module.exports = {"621027100":"城关镇","621027101":"屯字镇","621027102":"孟坝镇","621027103":"三岔镇","621027104":"平泉镇","621027105":"开边镇","621027106":"太平镇","621027107":"临泾镇","621027108":"新城镇","621027201":"南川乡","621027202":"上肖乡","621027203":"新集乡","621027204":"方山乡","621027205":"殷家城乡","621027206":"马渠乡","621027207":"庙渠乡","621027208":"武沟乡","621027209":"郭原乡","621027210":"中原乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/621027.json
// module id = 2733
// module chunks = 0